import { en, it } from 'vuetify/locale';
//import en from './en.json';
import enMessages from './en';
import fr from './fr/fr.json';
import itMessages from './it';
import ar from './other/ar.json';
import zh from './other/zh.json';

const ita = {
    $vuetify: { ...it },
    ...itMessages
}
const eng = {
    $vuetify: { ...en },
    ...enMessages
}
const fra = {
    $vuetify: { ...fr },
}
const ara = {
    $vuetify: { ...ar },
}
const zho = {
    $vuetify: { ...zh },
}

const messages = {
    it: ita,
    en: eng,
    fr: fra,
    ar: ara,
    zh: zho,
}



export default messages;
